import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { isMobile } from 'helpers/detect-mobile';

export class FRInput extends PureComponent {
  static propTypes = {
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    noAutoComplete: PropTypes.bool,
    forceBlur: PropTypes.bool,
  };

  static defaultProps = {
    onBlur: null,
    onChange: null,
    noAutoComplete: false,
    forceBlur: false,
  };

  // Internal state which indicates if the value has ever been changed
  dirty = false;
  input = null;

  handleBlur = (...args) => {
    const { onBlur, forceBlur } = this.props;
    this.dirty = true;
    if (forceBlur || this.dirty) {
      if (onBlur) {
        onBlur(...args, this.input);
      }
      this.dirty = false;
    }
  };

  handleChange = (...args) => {
    const { onChange } = this.props;

    this.dirty = true;
    if (onChange) {
      onChange(...args, this.input);
    }
  };

  render() {
    const { onBlur, onChange, noAutoComplete, forceBlur, ...rest } = this.props;

    return (
      <TextField
        {...rest}
        inputRef={(c) => {
          this.input = c;
          if (rest.inputRef) {
            rest.inputRef(c);
          }
        }}
        onBlur={this.handleBlur}
        onChange={this.handleChange}
        autoComplete={isMobile || noAutoComplete ? 'off' : ''}
      />
    );
  }
}

export default FRInput;
